export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const CATEGORIES = [
  { key: "WRD", label: "Website Redesign" },
  { key: "SMC", label: "Social Media Campaign" },
  { key: "LPL", label: "Luxury Property Launch" },
  { key: "PAC", label: "Paid Ads Campaign" },
  { key: "BIR", label: "Brand Identity Refresh" },
];

// Per-category colour palette (border + subtle background tint)
export const CATEGORY_COLORS = {
  WRD: { border: "#3b82f6", bg: "#eff6ff" },
  SMC: { border: "#14b8a6", bg: "#f0fdfa" },
  LPL: { border: "#818cf8", bg: "#eef2ff" },
  PAC: { border: "#f87171", bg: "#fff1f2" },
  BIR: { border: "#fbbf24", bg: "#fffbeb" },
};

export const PRIORITY_COLOR = {
  High:   "#ef4444",
  Medium: "#f59e0b",
  Low:    "#22c55e",
};

// daySpan = how many day-columns the card spans (1 = normal)
export const MOCK_TASKS = [
  {
    id: 1,
    title: "Website Redesign",
    status: "Brainstorming",
    priority: "High",
    day: "Monday",
    daySpan: 1,
    category: "WRD",
    team: ["James", "Martin", "Ruby", "Justin"],
    roles: ["Content Writer", "Graphic Designer", "Animation Designer"],
  },
  {
    id: 2,
    title: "Social Media Campaign",
    status: "Copy Drafting",
    priority: "Low",
    day: "Tuesday",
    daySpan: 1,
    category: "SMC",
    team: ["James", "Martin", "Ruby", "Justin"],
    roles: ["Content Writer", "Graphic Designer", "Video Editor", "Copywriter", "SEO Specialist"],
  },
  {
    id: 3,
    title: "Luxury Property Launch Campaign",
    status: "Work Started",
    priority: "Medium",
    day: "Wednesday",
    daySpan: 1,
    category: "LPL",
    team: ["James", "Martin", "Ruby", "Justin"],
    roles: ["Content Writer", "Graphic Designer", "Animation Designer"],
  },
  {
    id: 4,
    title: "Paid Ads Campaign",
    status: "Design in Progress",
    priority: "High",
    day: "Tuesday",
    daySpan: 4,           // spans Tuesday → Friday
    category: "PAC",
    team: ["James", "Martin", "Ruby", "Justin"],
    roles: ["Content Writer", "Graphic Designer", "Animation Designer"],
  },
  {
    id: 5,
    title: "Brand Identity Refresh",
    status: "Work Started",
    priority: "Low",
    day: "Monday",
    daySpan: 1,
    category: "BIR",
    team: ["James", "Martin", "Ruby", "Justin"],
    roles: ["Content Writer", "Graphic Designer"],
  },
];

export const SUMMARY_STATS = {
  totalProjects:      5,
  activeProjects:     6,
  inactiveProjects:   2,
  resourcesAllocated: 12,
};